import { FC, useState } from 'react';
import CenterModal from '../../component/centerModal/centerModal';
import { renderChangePasswordInputView } from './profileHelper';
import { ChangePasswordModalProps } from './profile.type';
import { useChangeProfilePassword } from '../../hooks/useAuthData';
import {
  apiStatusCode,
  ErrorMessages,
  StorageKey,
} from '../../utils/helper.type';
import { isUndefined } from 'lodash';
import { ForgotPasswordResponse } from '../../service/service.type';

const ChangePasswordModal: FC<ChangePasswordModalProps> = (props) => {
  const [currentPassword, setCurrentPassword] = useState<string>('');
  const [newPassword, setNewPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showCurrentPassword, setShowCurrentPassword] =
    useState<boolean>(false);
  const [showNewPassword, setShowNewPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  const {
    changeProfilePassword,
    changeProfilePasswordLoading,
    error,
    setError,
  } = useChangeProfilePassword();

  const handleSubmit = async () => {
    const idpToken: string | null = localStorage.getItem(StorageKey.IDP_TOKEN);
    setError(null);
    if (newPassword !== confirmPassword) {
      setError(ErrorMessages.PASSWORD_MISMATCH);
      return;
    }
    try {
      const changeProfilePasswordResponse: ForgotPasswordResponse | undefined =
        await changeProfilePassword(
          currentPassword,
          newPassword,
          idpToken ?? '',
        );
      if (!isUndefined(changeProfilePasswordResponse)) {
        console.log(`[UpdateUser] response `, changeProfilePasswordResponse);
        if (
          changeProfilePasswordResponse?.statusCode === apiStatusCode.SUCCESS
        ) {
          console.log(`[UpdateUser] close modal `);

          props.onClose();
        }
      }
    } catch (error: unknown) {
      console.warn(`[ChangeProfilePassword]`, { error });
      throw error;
    } finally {
      console.warn(`[ChangeProfilePassword] finally block...`);
    }
  };

  return (
    <CenterModal
      isOpen={props.isOpen}
      showClearButton
      showCenterHeader
      onClose={props.onClose}
      onClear={() => {
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        setShowCurrentPassword(false);
        setShowNewPassword(false);
        setShowConfirmPassword(false);
      }}
      title={'profile.changePassword'}
      onSubmit={handleSubmit}
      clearText={'profile.clear'}
      successText={'profile.confirm'}
      isLoading={changeProfilePasswordLoading}
      isDisabled={!currentPassword || !newPassword || !confirmPassword}
    >
      {renderChangePasswordInputView(
        handleSubmit,
        currentPassword,
        setCurrentPassword,
        newPassword,
        setNewPassword,
        confirmPassword,
        setConfirmPassword,
        props.loginTranslation,
        showCurrentPassword,
        setShowCurrentPassword,
        showNewPassword,
        setShowNewPassword,
        showConfirmPassword,
        setShowConfirmPassword,
        error,
      )}
    </CenterModal>
  );
};

export default ChangePasswordModal;
